import { Component } from '@angular/core';

@Component({
  selector: 'app-care-egyptian-investors',
  templateUrl: './care-egyptian-investors.component.html',
  styleUrl: './care-egyptian-investors.component.scss'
})
export class CareEgyptianInvestorsComponent {

}
